<template>
  <div class="App">
    <div class="Content" v-if="CompOnlyEmail">
      <OnlyEmail @ListenChildren="ListenOnlyEmail" />
    </div>
    <div class="Content" v-if="CompCode">
      <EmailCode @ListenChildrenPassword="ListenEmailCode" />
    </div>
    <div class="Content" v-if="CompPassword">
      <NewPassword />
    </div>
    <div class="Imagenes">
      <sliderVue style="height: 100vh; border: none; margin: 0" />
    </div>
  </div>
</template>
<script>
import sliderVue from "../components/Login/slider.vue";
import EmailCode from "../components/Login/EmailCode.vue";
import OnlyEmail from "../components/Login/OnlyEmail.vue";
import NewPassword from "../components/Login/NewPassword";

export default {
  name: "RecuperarContrasena1",
  components: { sliderVue, EmailCode, OnlyEmail, NewPassword },
  data: () => ({
    CompOnlyEmail: true,
    CompCode: false,
    CompPassword: false,
  }),
  methods: {
    ListenOnlyEmail(value) {
      this.CompCode = !value;
      this.CompOnlyEmail = value;
    },
    ListenEmailCode(value) {
      console.log("Está llegnado");
      this.CompPassword = !value;
      this.CompCode = value;
    },
  },
};
</script>
<style lang="css" scoped>
.App {
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 50% 50%;
}
.Imagenes {
  width: 100%;
  height: 100%;
}

@media (max-width: 800px) {
  .App {
    grid-template-columns: auto;
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url("../assets/imagen1.jpg");
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
    height: 100vh;
  }

  .Imagenes {
    display: none;
  }
}
</style>